import { sumStringLength } from '../../helpers/sumStringLength';
import { checkDigitsCount, checkMaxLength, checkNotEmpty } from '../../helpers/validators';
export const getBankValidationInfo = ({ requisites, required, }) => {
    const isBankRequired = required || sumStringLength(Object.values(requisites)) > 0;
    const checkBankRequired = (value) => {
        return isBankRequired ? checkNotEmpty({ value, type: 'lostfocus', independent: false }) : null;
    };
    return {
        name: checkBankRequired(requisites.name) || checkMaxLength({ value: requisites.name || '', length: 120 }),
        bik: checkBankRequired(requisites.bik) || checkDigitsCount(requisites.bik, 9),
        paymentAccount: checkBankRequired(requisites.paymentAccount) || checkDigitsCount(requisites.paymentAccount, 20),
        bankCombo: checkBankRequired(requisites.name) || checkBankRequired(requisites.bik),
    };
};
